import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { v4 as uuidv4 } from "uuid";


import { WalletConnectService } from 'src/app/services/wallet-connect.service';
import { SwapStatus } from 'src/app/shared/constants/app-enums';
import { environment } from 'src/environments/environment';
import WertWidget from '@wert-io/widget-initializer';
import { HttpClient } from '@angular/common/http';
import { EventService } from 'src/app/services/event.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-swap',
  templateUrl: './swap.component.html',
  styleUrls: ['./swap.component.scss']
})

export class SwapComponent implements OnInit {

  @Output() messageEvent = new EventEmitter<string>();
  @ViewChild('swapIn') swapIn: ElementRef<HTMLInputElement> | null = null;
  private subscriptions: Subscription[] = [];
  environtment = environment;
  baseToken: number = 0;
  swapToken = 0;
  baseCurrencyValue: any;
  tokenUpdate = new Subject<any>();
  tokenUpdate2 = new Subject<any>();
  contractData: any;
  SwapStatus = SwapStatus;
  lblockPrice = 0;
  isLowBalance = false;
  connectInterval: any;
  usdtBal: number = 0;
  nativeBal: number = 0;
  minAmount = 100;
  isNative: boolean = false;
  isWert: boolean = false;

  // ----- wert variables ----

  wertMode: boolean = false;
  wertWidget: any;
  wertOptions: any = {
    partner_id: environment.partnerId,
    origin: environment.wertOrigin,
    click_id: uuidv4(), // must be unique for any request
    lang: 'en',
    theme: 'light',
    currency: 'USD',
    commodity: environment.production ? "ETH:ethereum" : "ETH:Ethereum-Goerli",
    container_id: 'wertCont',
    height: 506
  }

  gasFeesETH: number = 0.015;
  gasFeesBSC: number = 0.0025;

  constructor(
    public dialogRef: BsModalRef,
    private walletConnect: WalletConnectService,
    private http: HttpClient,
    private eventService: EventService
  ) {
    //to check the value of swap
    this.subscriptions.push(this.tokenUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
      .subscribe(value => {
        console.log(this.swapToken, value);
        if (this.swapToken >= 0) {
          this.calculateSwap();
        } else {
          this.baseToken = 0;
        }
      }));
    this.subscriptions.push(this.tokenUpdate2.pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
      .subscribe(value => {
        console.log(this.swapToken, value);
        if (this.baseToken >= 0) {
          this.calculateSwapReverse();
        } else {
          this.swapToken = 0;
        }
      }));
  }

  ngOnInit(): void {
    this.walletConnect.swapStatus = SwapStatus.not_started;
    this.getBal();
    this.isLowBalance = false;
  }

  max() {
    this.swapToken = (this.isNative ? (this.nativeBal - this.gasFees > 0 ? this.nativeBal - this.gasFees : 0) : this.usdtBal);
    this.tokenUpdate.next(this.swapToken)
    setTimeout(() => this.swapIn?.nativeElement.blur(), 200);
  }

  getBal() {
    this.nativeBal   = +this.walletConnect.balanceData.nativeBal.toFixed(10).replace(/0{0,10}$/, "");
    this.usdtBal  = this.walletConnect.balanceData.usdtBal;
    if (!this.isWert) this.max();
  }

  get walletAddress(): any {
    return this.walletConnect.walletAddress;
  }

  get status() {
    return this.walletConnect.swapStatus;
  }

  get hash() {
    return this.walletConnect.swapHash;
  }

  get tokenName() {
    return this.isNative ? (this.isBsc ? "BNB" : "ETH") : "USDT";
  }
  get modeName() {
    return this.isBsc ? "BNB" : "ETH";
  }

  get gasFees() {
    return this.isBsc ? this.gasFeesBSC : this.gasFeesETH;
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    clearInterval(this.connectInterval);
  }

  closePopup(message: string ='Transaction Cancelled'): void {
    clearInterval(this.connectInterval);
    this.messageEvent.emit(message);
    this.dialogRef.hide();
  }

  confirm() {
    if (this.isWert) {
      this.showWertWidget();
    } else {
      if (this.swapToken !== 0 && this.baseToken >= this.minAmount)
        this.createSwap();
    }
  }

  calculateSwap = async () => {
    this.checkLowBalance();
    if (this.isNative) {
      if (this.isBsc) {
        this.baseToken = await this.walletConnect.getBnbAmount(this.swapToken * 0.98);
      } else {
        this.baseToken = await this.walletConnect.getEthAmount(this.swapToken * 0.98);
      }
    } else {
      this.baseToken = await this.walletConnect.getUSDTAmount(this.swapToken * 0.98);
    }
    this.baseToken = +this.baseToken.toFixed(0).replace(/0{0,0}$/, "");
    console.log("calculateSwap here", this.isNative, this.swapToken, this.baseToken);
  }

  calculateSwapReverse = async () => {
    if (this.isNative) {
      if (this.isBsc) {
        this.swapToken = await this.walletConnect.getDynamicAmount(this.baseToken, 'getBnbAmount');
      }else{
        this.swapToken = await this.walletConnect.getDynamicAmount(this.baseToken, 'getEthAmount');
      }
    } else {
      this.swapToken = await this.walletConnect.getDynamicAmount(this.baseToken * 1.02, 'getUSDTAmount');
    }
    this.swapToken = +(this.swapToken * 1.001).toFixed(10).replace(/0{0,10}$/, "");
    this.checkLowBalance();
    console.log("calculateSwapReverse here", this.swapToken);
  }

  async createSwap() {

    this.walletConnect.swapStatus = SwapStatus.not_started;
    try {
      if (this.isNative) {
        if ((this.nativeBal - this.gasFees) >= this.swapToken) {
          this.isLowBalance = false;
          if (this.isBsc) {
            await this.walletConnect.swapBnbTokens(this.baseToken, this.swapToken);
          } else {
            await this.walletConnect.swapEthTokens(this.baseToken, this.swapToken);
          }
        } else {
          this.isLowBalance = true;
        }
      } else {
        if (this.usdtBal >= this.swapToken && this.nativeBal >= this.gasFees) {
          this.isLowBalance = false;
          await this.walletConnect.swapCryptoForUSDT(this.baseToken, this.swapToken);
        } else {
          this.isLowBalance = true;
        }
      }
    }
    catch (err: any) {
      console.log(err);
      if (err && err.code == 4001) {
        this.walletConnect.swapStatus = SwapStatus.rejected;
      } else {
        this.walletConnect.swapStatus = SwapStatus.failed;
      }
    }
  }

  viewUrl() {
    const blkUrl = this.isBsc ? this.environtment.bsc.blockExplorerURL : this.environtment.eth.blockExplorerURL
    window.open( blkUrl + this.hash, '_blank');
  }

  get cryptoName() {
    return environment.tokenName;
  }

  changeMode(isEth: boolean): void {
    this.isNative = isEth;
    this.getBal();
    this.isLowBalance = false;
    this.checkLowBalance();
  }

  async showWertWidget(): Promise<any> {
    this.wertMode = true;
    let ethValue = await this.walletConnect.getDynamicAmountWert(this.baseToken);
    let data = {
      address: this.walletAddress,
      commodity: environment.production ? "ETH" : "ETH:Ethereum-Goerli",
      commodity_amount: +((ethValue * 1.02).toFixed(8)),
      pk_id: "key1",
      sc_address: environment.eth.presaleAddress,
      sc_id: uuidv4(), // must be unique for any request
      sc_input_data: await this.walletConnect.getABI(this.baseToken),
    };

    this.http.post(environment.wertUrl, data).subscribe((res: any) => {
      const signedData = res.data;
      let isDashFXSent = false;

      console.log('wertOptions =', signedData, this.wertOptions);

      this.wertWidget = new WertWidget({
        ...signedData,
        ...this.wertOptions,
        listeners: {
          loaded: () => console.log('widget loaded:'),
          close: () => console.log('widget closed:'),
          position: (data: any) => console.log('step:', data.step),
          'payment-status': (status: any) => {
            console.log('payment-status:', status);
            if ((status.status == 'progress' || status.status == 'success') && !isDashFXSent) {
              this.walletConnect.sendDashFx('eth', this.baseToken, +((ethValue).toFixed(8)));
              isDashFXSent = true;
            }
          },
          error: (err: any) => console.log('error:', err),
        },
      });
      this.wertWidget.mount();
    },
    (err: any) => {
      console.log('wert error response', err);
    })
  }

  checkLowBalance(): void {
    if (this.isNative) {
      if ((this.nativeBal - this.gasFees) >= this.swapToken) {
        this.isLowBalance = false;
      } else {
        this.isLowBalance = true;
      }
    } else {
      if (+this.usdtBal >= +this.swapToken && +this.nativeBal >= this.gasFees) {
        this.isLowBalance = false;
      } else {
        this.isLowBalance = true;
      }
    }
  }

  openWert(): void {
    this.eventService.broadcastEvent("OPEN_WERT", true);
  }

  get isBsc() {
    return this.eventService.isBsc;
  }
}
